"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  cutTime: {
    vesselAndVoyage: '船名&航次',
    startTime: '起始时间',
    endTime: '结束时间',
    form: '至',
    pol: '装货港',
    port: '港口',
    etdNotNull: 'ETD 不能为空',
    vesselAndVoyageNotNull: '船名&航次不能为空',
    vesselAndVoyageOrEtdNotNull: '船名&航次、ETD至少一个不能为空',
    etdBetween: 'ETD时间不能超过68天',
    dgDeadlineTime: '危险品申报截止时间',
    frCutOffTime: 'RF冷箱清单截单时间',
    akCutOffTime: '特种箱清单截单时间',
    cutVgmDate: 'VGM截止时间'
  },
  cutTimeTable: {
    vesselCode: "船舶代码",
    voy: "VOY",
    leg: "LEG",
    portCode: "PORT CODE",
    etd: 'ETD',
    sailingDate: "SAILING DATE",
    docCutTime: "DOC CUT TIME",
    cyCutTime: "CY CUT TIME",
    dgDeadlineTime: '危险品申报截至时间',
    frCutOffTime: 'RF冷箱清单截单时间',
    akCutOffTime: '特种箱清单截单时间',
    ladenOnBoard: '装船时间'
  }
};